import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { testimonials } from '@/mocks/testimonials';

const duplicatedTestimonials = [...testimonials, ...testimonials];

export default function TestimonialsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="depoimentos" className="relative py-24 md:py-32 lg:py-40 bg-dark-900 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="text-center mb-16 md:mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-premium-400 text-xs tracking-[0.3em] uppercase font-medium"
          >
            Depoimentos
          </motion.span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4">
            A palavra de{' '}
            <span className="text-gradient-gold">quem confia</span>
          </h2>
          <motion.div
            initial={{ width: 0 }}
            animate={isInView ? { width: '80px' } : {}}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="h-[1px] bg-premium-500 mx-auto mt-6"
          ></motion.div>
        </div>

        <div className="relative overflow-hidden" style={{ maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)' }}>
          <motion.div
            className="flex gap-6"
            animate={{ x: ['0%', '-50%'] }}
            transition={{ repeat: Infinity, duration: 40, ease: 'linear' }}
            style={{ width: 'fit-content' }}
            whileHover={{ animationPlayState: 'paused' }}
          >
            {duplicatedTestimonials.map((item, idx) => (
              <div
                key={`${item.id}-${idx}`}
                className="flex-shrink-0 w-[340px] md:w-[400px] bg-dark-800 rounded-lg p-6 md:p-7 border border-white/5 hover:border-white/10 transition-colors duration-300"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-premium-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-white/70 text-sm leading-relaxed mb-5 font-light">
                  "{item.text}"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                  <div className="w-9 h-9 rounded-full bg-premium-600/30 flex items-center justify-center">
                    <span className="text-premium-400 text-sm font-medium">
                      {item.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">{item.name}</p>
                    <p className="text-white/40 text-xs">Cliente</p>
                  </div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}